// src/components/policies/PolicyDisclaimer.js
import React from 'react';
import { AlertTriangle } from 'lucide-react';

const PolicyDisclaimer = () => {
  return (
    <div
      className="flex items-start gap-3 p-4 rounded-lg"
      style={{
        backgroundColor: '#FFFBEB',
        border: '1px solid #FEF3C7',
      }}
    >
      <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
      <div className="text-sm text-amber-900 leading-relaxed">
        <strong className="font-semibold">Legal Disclaimer:</strong> These templates are provided for informational purposes only.
        Divine Frameworks does not provide legal advice. We recommend having your policies reviewed by a qualified attorney
        to ensure they meet your specific business needs and comply with applicable laws.
      </div>
    </div>
  );
};

export default PolicyDisclaimer;
